export const TRIAL = 'FLAG_TRIAL';

export const LOW_QUOINS = 2;

export const MERCURY_DOCUMENT_TITLE = (title: string) => `Mercury | ${title}`;

export const QUOINTELLIGENCE_CLIENT_ID = '1751';
